var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/roundedCross.5db486ff.png","uri@2x": __webpack_public_path__ + "static/media/roundedCross.bee93317.png","uri@3x": __webpack_public_path__ + "static/media/roundedCross.0f391d7a.png",
    width: 14,
    height: 14
});